import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faMoped } from '@fortawesome/pro-light-svg-icons';
import { Text } from '@querodelivery/uni-react';
import { celularLabel } from '@/Utils/FnUtils';
import type { MonitorDeliveryDetailDeliveryman } from '../../../../types';
import { formatDeliverymanName, getWhatsappUrl } from '../../../../utils';
import styles from './deliveryman-info.module.scss';

interface DeliverymanInfoProps {
  deliveryman: MonitorDeliveryDetailDeliveryman;
}

export function DeliverymanInfo({ deliveryman }: DeliverymanInfoProps) {
  return (
    <div className={styles.deliveryman}>
      <span className={styles.label}>
        <FontAwesomeIcon icon={faMoped} className={styles.mopedIcon} />
        <Text
          as="span"
          fontSize="sm"
          fontWeight="medium"
          lineHeight="lg"
          tone="supporting"
        >
          Entregador
        </Text>
      </span>

      <div className={styles.row}>
        <Link
          to={`/entregadores/${deliveryman.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.name}
        >
          <Text
            as="span"
            fontSize="sm"
            fontWeight="bold"
            lineHeight="lg"
            tone="inherit"
            truncate
          >
            {formatDeliverymanName(deliveryman.name)}
          </Text>
        </Link>

        {deliveryman.phone && (
          <a
            className={styles.phone}
            href={getWhatsappUrl(deliveryman.phone)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Falar com o entregador no WhatsApp: ${celularLabel(
              deliveryman.phone,
            )}`}
          >
            <FontAwesomeIcon
              icon={faWhatsapp}
              className={styles.whatsappIcon}
            />
            <Text
              as="span"
              fontSize="sm"
              fontWeight="medium"
              lineHeight="lg"
              tone="inherit"
            >
              {celularLabel(deliveryman.phone)}
            </Text>
          </a>
        )}
      </div>
    </div>
  );
}
